module.exports = __webpack_public_path__ + "img/tank-vertical-selected.9014f2c9.svg";